import { portifolio1, portifolio2, apiTempo, astronomy, login, cellphone, voice, socialMedia, inglesCoffe } from "../../assets/"

const values = {
    site9: {
        img: inglesCoffe,
        titulo: "English for Brazilians",
        linkToGit: "https://github.com/Deny-santos/ingles-coffe-just-front-end.git",
        description: "Developed in: Next.js + tailwind. amazing and Super useful site for studying English words and expressions. +dark mode, +skeleton",
        linkToShowProject: "https://ingles-coffe.netlify.app/"
    },
    site1: {
        img: astronomy,
        titulo: "Astronomy",
        linkToGit: "https://github.com/Deny-santos/whatsbeyond",
        description: "Developed in: React. Educational website, focusing on scientific dissemination about Astronomy",
        linkToShowProject: "https://astronomy-deny.netlify.app/"
    },
    site2: {
        img: cellphone,
        titulo: "Filter Cellphone By Name And Brand",
        linkToGit: "https://github.com/Deny-santos/filter-by-cellphone.git",
        description: "Developed in: React.js + Styled-components. made for practicing state management with useContext",
        linkToShowProject: "https://deny-filter-cellphone.netlify.app/"
    },
    site3: {
        img: apiTempo,
        titulo: "Get Weather",
        linkToGit: "https://github.com/Deny-santos/tempo",
        description: "Developed in: Javascript. weather query website by city name, consuming the get weather api",
        linkToShowProject: "https://deny-santos.github.io/tempo/"
    },
    site4: {
        img: portifolio1,
        titulo: "React Portfolio",
        linkToGit: "https://github.com/Deny-santos/portifolio-fullstack-1",
        description: "Developed in: React + Sanity.  Portfolio for non-professional use with a sanity backend. Using Framer Motion for Animation",
        linkToShowProject: "https://portifolio-deny.netlify.app/"
    },
    site5: {
        img: login,
        titulo: "Login Page",
        linkToGit: "https://github.com/Deny-santos/check",
        description: "Developed in: Javascript.  form example with custom checkbox",
        linkToShowProject: "https://deny-santos.github.io/check/"
    },
    site6: {
        img: portifolio2,
        titulo: "Portfolio JS, HTML5, CSS3",
        linkToGit: "https://github.com/Deny-santos/site-deny",
        description: "Developed in: JavaScript.  portfolio example",
        linkToShowProject: "https://deny-santos.github.io/site-deny/"
    },
    site7: {
        img: voice,
        titulo: "Voice Recognation",
        linkToGit: "https://github.com/Deny-santos/voice-recognition",
        description: "Developed in: javascript. voice recognition, try to speak in another language.",
        linkToShowProject: "https://deny-santos.github.io/voice-recognition/"
    },
    site8: {
        img: socialMedia,
        titulo: "Social Media, Material UI",
        linkToGit: "https://github.com/Deny-santos/social-media-material-ui.git",
        description: "Developed in: React + Material UI.  Social Media design.",
        linkToShowProject: "https://deny-social-media.netlify.app/"
    },
}

export const sites = [values.site9, values.site1, values.site8, values.site2, values.site3, values.site4, values.site5,values.site6, values.site7]